import { useContext } from 'react';

import { TimeseriesChartXScaleContext } from '../context/TimeseriesChartXScale.context.js';

export const useXScales = () => useContext(TimeseriesChartXScaleContext);
